/**
 * Main Nav
 *
 * @returns {{init: init}}
 */
export default (() => {
  const DOM = {};
  const isDesktopBreakpoint = window.matchMedia("(min-width: 768px)");

  const cacheDOM = () => {
    DOM.parentMenu = document.getElementsByClassName("menu-item-has-children");
    DOM.subMenu = document.getElementsByClassName("sub-menu");
  };

  const subMenuPanelHeight = (subMenuWrapper) => {
    let elementTotalHeight = 0;
    Array.from(subMenuWrapper.children).forEach((menu) => {
      elementTotalHeight += menu.clientHeight;
    });
    return elementTotalHeight;
  };

  const isParentMenu = element => element.parentNode.classList.contains("menu-item-has-children");

  const openSubMenu = (event) => {
    event.preventDefault();
    const parentMenu = isParentMenu(event.target);
    if (parentMenu) {
      const subMenuWrapper = event.target.nextElementSibling;
      const subMenuWrapperHeight = subMenuPanelHeight(subMenuWrapper);

      subMenuWrapper.style.height = `${subMenuWrapperHeight}px`;
    }
  };

  const closeSubMenu = (event) => {
    event.preventDefault();
    Array.from(DOM.subMenu).forEach((submenuPanel) => {
      submenuPanel.style.height = "0px"; // eslint-disable-line no-param-reassign
    });
  };

  const eventListeners = () => {
    Array.from(DOM.parentMenu).forEach((menu) => {
      menu.addEventListener("mouseover", openSubMenu);
      menu.addEventListener("mouseleave", closeSubMenu);
    });
  };

  const checkForScreenSize = (e) => {
    if (e.matches) {
      eventListeners();
    }
  };

  const init = () => {
    cacheDOM();
    isDesktopBreakpoint.addListener(checkForScreenSize);
    checkForScreenSize(isDesktopBreakpoint);
  };

  return {
    init
  };
})();
